export default __webpack_public_path__ + "static/media/CO.13b1481e.jpg";